module.exports = __webpack_public_path__ + "static/media/controls_next.2c7b4a18.svg";